import * as React from "react";
function HistoryRecentIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.75c5.799 0 10.5-4.701 10.5-10.5s-4.701-10.5-10.5-10.5S3 6.451 3 12.25V13a.75.75 0 0 0 1.5 0v-.75a9 9 0 1 1 9 9 .75.75 0 0 0 0 1.5M.22 10.527l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-3 3h1.06l-3-3a.75.75 0 0 0-1.06 1.06M12 6.247v6.75c0 .414.336.75.75.75H18a.75.75 0 0 0 0-1.5h-5.25l.75.75v-6.75a.75.75 0 0 0-1.5 0"
  }));
}
export default HistoryRecentIcon;